/**
 * API Service: Auth
 * Handles authentication API calls
 */

import axios from "axios";
import { config as appConfig } from "@/config";
import type { LoginCredentials, LoginResponse } from "../../../domain/model/AuthModel";

export class AuthApiService {
  /**
   * Call login API endpoint
   */
  async login(credentials: LoginCredentials): Promise<LoginResponse> {
    const response = await axios.post<LoginResponse>(
      `${appConfig.api.baseUrl}/api/v1/auth/login`,
      credentials,
      {
        headers: {
          "Content-Type": "application/json",
        },
      },
    );
    return response.data;
  }
}

